import type { Apollo } from 'src/gql/generated';
import type { AccountSubset } from 'src/types/apollo/accounts';

export interface WorkflowPermissionSubset extends Pick<
  Apollo.WorkflowPermission,
  | 'accessLevel'
  | 'avatarColor'
  | 'id'
  | 'isAssignee'
  | 'timeliness'
  | '__typename'
  | 'isExternal'
  | 'isLauncher'
  | 'roleName'
> {
  account: AccountSubset | null;
}

/** A slot filled later rather than a person: an unfilled role or the template's launcher. */
export function getIsPlaceholderPermission(permission: {
  account: Pick<AccountSubset, '__typename'> | null;
  roleName: string | null;
  isLauncher?: boolean;
}): boolean {
  return Boolean(permission.isLauncher) || getIsRolePermission(permission);
}

/** An unfilled role placeholder. Role names repeat, so a placeholder is identified by its permission id. */
export function getIsRolePermission(permission: {
  account: Pick<AccountSubset, '__typename'> | null;
  roleName: string | null;
}): boolean {
  return Boolean(permission.roleName) && permission.account?.__typename !== 'User';
}
